import { createGlobalStyle } from "styled-components";

// export const TableStyles = createGlobalStyle`
//     .data-table{
//         width: 100%;
//         overflow-x: auto;

//         table{
//             width: 100%;
//             background-color: var(--light-gray);
//     // display: flex;
//     // flex-direction: column;
//     background-color: var(--light-gray);
//     gap: 1.5rem;
// }

// tbody{
//     display: flex;
//     flex-direction: column;
//     gap: 2rem;
// }

// th{
//     background-color: #fff;
//     font-weight: 600;
//     font-size: 1.4rem;
//     padding: 1rem 0;
//     width: 10rem;
//     text-align: start;
// }

// // tr{
// //     display: flex;
// //     justify-content: space-between;
// //     background-color: #fff;
// //     padding: 1rem 2rem;
// //     align-items: center;
// //     border-radius: 1rem;
// //     gap: 1rem;
// // }<table><thead><tr style="
//     /* width: 100% !important; */
// "><th class="">Name</th><th class="">Email</th><th class="">Phone Number</th><th class="th">Gender</th><th class="th">Location</th><th class="th">Status</th><th class="th">Actions</th></tr></thead><tbody><tr><td><img src="https://api.dev.indievore.com/images/1738837350983-1000310722.jpg" alt="img" class="img">Edward Thomson</td><td>edward@yopmail.com</td><td>4147081234</td><td>Male</td><td>Null</td><td><label class="toggle-button"><input type="checkbox"><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://api.dev.indievore.com/images/1739273526665-1000001803.png" alt="img" class="img">hana</td><td>hana@yopmail.com</td><td>1525865258</td><td>Female</td><td>Null</td><td><label class="toggle-button"><input type="checkbox"><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://api.dev.indievore.com/images/1739865656653-e0be7938-05a5-4daa-8a93-61a138a4bc944365214459162378772.jpg" alt="img" class="img">StylisH stricker</td><td>marsstricker@gmail.com</td><td>1234567890</td><td>Male</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://api.dev.indievore.com/images/1739881563842-1000059858.jpg" alt="img" class="img">Iman</td><td>iman@yopmail.com</td><td>5464846484</td><td>Female</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://api.dev.indievore.com/images/1738158792062-images.jpg" alt="img" class="img">Maria Smith</td><td>maria@yopmail.com</td><td>3052586580</td><td>Female</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://api.dev.indievore.com/images/1738154171019-1000022094.jpg" alt="img" class="img">Anna Clark</td><td>Anna@yopmail.com</td><td>3580852458</td><td>Female</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://api.dev.indievore.com/images/1738310270185-1000055202.jpg" alt="img" class="img">Test User</td><td>test2@yopmail.com</td><td>6582585680</td><td>Female</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://picsum.photos/200" alt="img" class="img">John Doe</td><td>user1@example.com</td><td></td><td>Null</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://picsum.photos/200" alt="img" class="img">Iman Fatima</td><td>if267@gmail.com</td><td></td><td>Null</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr><tr><td><img src="https://api.dev.indievore.com/images/1738301203770-1000000156.jpg" alt="img" class="img">khizar</td><td>khizaraslam201@yopmail.com</td><td>2255555598</td><td>Male</td><td>Null</td><td><label class="toggle-button"><input type="checkbox" checked=""><span class="slider round"></span></label></td><td><div class=" view-container"><img src="/static/media/view-icon.083363bfe3810e0a614c2ae4663c8bcb.svg" alt="img"></div></td></tr></tbody></table>

// td{
//     padding: 0.5rem 0;
//     cursor: pointer;
//     font-size: 1.4rem;
//     color: #585562;
//     // display: flex;
//     align-items: center;
//     gap: 1.5rem;

// }
//     }
// `;

export const TableStyles = createGlobalStyle`
  .data-table {
    width: 100%;
    overflow-x: auto;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    background-color: var(--light-gray);
  }

  thead {
   background-color: #fff;
    font-weight: 600;
    font-size: 1.4rem;
    padding: 1rem 0;
    width: 10rem;
    text-align: start;
    border-bottom: 10px solid var(--light-gray);
  }

  th {
    font-weight: 600;
    font-size: 1.4rem;
    padding: 2rem;
    text-align: left;
    color: #333;
  }

  tbody tr {
    background-color: #fff;
    border-bottom: 10px solid var(--light-gray);
    transition: background-color 0.2s ease-in-out;
  }

//   tbody tr:hover {
//     background-color: #f9f9f9;
//   }

  td {
    padding: 2rem;
    font-size: 1.4rem;
    color: #585562;
    vertical-align: middle;
  }

  td img.img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 1rem;
    vertical-align: middle;
  }

  .toggle-button {
    display: inline-block;
    position: relative;
    width: 50px;
    height: 24px;
  }

  .toggle-button input {
    display: none;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 24px;
  }

  .slider.round::before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  .toggle-button input:checked + .slider {
    background-color: #4caf50;
  }

  .toggle-button input:checked + .slider::before {
    transform: translateX(26px);
  }

  .view-container {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .view-container img {
    width: 20px;
    height: 20px;
  }
`;
